"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationDelayPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var react_datepicker_1 = require("react-datepicker");
var en_GB_1 = require("date-fns/locale/en-GB");
var CancellationDelayRequest_1 = require("../../model/CancellationDelayRequest");
var moment = require("moment");
var CancellationDelayPagePlain = /** @class */ (function (_super) {
    __extends(CancellationDelayPagePlain, _super);
    function CancellationDelayPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.handleOnSubmit = function (event) {
            var _a;
            event.preventDefault();
            if (_this.validate()) {
                var request = new CancellationDelayRequest_1.default();
                request.policyNumber = _this.props.params.number;
                request.delayDate = moment(_this.state.delayDate).utc(true).format();
                _this.setState({ loadingClaim: true });
                _this.supportPortalService.createCancellationDelay(request)
                    .subscribe(function (response) {
                    _this.setState({
                        resultCancellationDelayDate: response.cancellationDelayDate,
                        loadingClaim: false
                    });
                });
                _this.supportPortalService.logAgentActivity(_this.props.params.customer, { "action": "Delay cancellation", "customer": _this.props.params.number, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
            }
        };
        _this.handleDateChange = function (date) {
            _this.setState({ delayDate: date });
        };
        var maxDate = new Date(props.params.dueDate);
        var todayBeginningOfDay = new Date;
        var minDate = new Date(maxDate);
        minDate.setDate(maxDate.getDate() - 6);
        if (todayBeginningOfDay > minDate && todayBeginningOfDay <= maxDate) {
            minDate = todayBeginningOfDay;
        }
        _this.state = {
            minDate: minDate,
            maxDate: maxDate,
            delayDate: null,
            errors: []
        };
        return _this;
    }
    CancellationDelayPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ loadingPolicyVersion: true });
        this.supportPortalService.logAgentActivity(this.props.params.customer, { "action": "No Action", "customer": this.props.params.number }).subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
    };
    CancellationDelayPagePlain.prototype.render = function () {
        var _a, _b, _c, _d;
        if (this.supportPortalTemplates.userHasRole(["Administrator", "CSR_Lead", "CSR"])) {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.supportPortalTemplates.renderBackLink("Customer details", true, "/customers/".concat(this.props.params.customer)), (0, jsx_runtime_1.jsx)("div", { className: "banner info-banner", children: (0, jsx_runtime_1.jsxs)("p", { children: ["The cancellation can be delayed only for period: ", moment(this.state.minDate).format("DD-MM-yyyy"), "- ", moment(this.state.maxDate).format("DD-MM-yyyy")] }) }), (0, jsx_runtime_1.jsxs)("form", { className: "row panel-border px-3", onSubmit: this.handleOnSubmit, children: [this.state.errors.length > 0 &&
                                (0, jsx_runtime_1.jsx)("div", { className: "col-12 alert alert-danger", children: this.renderErrors() }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", children: "Select cancellation delay:" }), (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { selected: this.state.delayDate, onChange: this.handleDateChange, dateFormat: "dd-MM-yyyy", maxDate: this.state.maxDate, minDate: this.state.minDate, shouldCloseOnSelect: false, monthsShown: ((_b = (_a = this.state.maxDate) === null || _a === void 0 ? void 0 : _a.getMonth()) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = this.state.minDate) === null || _c === void 0 ? void 0 : _c.getMonth()) !== null && _d !== void 0 ? _d : 0) + 1, locale: en_GB_1.default, className: "form-control", popperPlacement: "bottom", popperModifiers: [
                                            {
                                                name: "flip",
                                                options: {
                                                    // don't allow it to flip to be above
                                                    allowedAutoPlacements: ["bottom"],
                                                    fallbackPlacements: ["bottom"]
                                                }
                                            },
                                            {
                                                name: "preventOverflow",
                                                enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                            },
                                            {
                                                name: "hide",
                                                enabled: false
                                            },
                                        ] })] }), (0, jsx_runtime_1.jsx)("div", { className: "form-group col-12 clearfix", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mr-0", children: "Confirm cancellation delay" }) }), this.state.resultCancellationDelayDate && ((0, jsx_runtime_1.jsxs)("div", { className: "alert alert-success col-12", children: [(0, jsx_runtime_1.jsx)("div", { children: "Cancellation delay created" }), (0, jsx_runtime_1.jsx)("div", { children: this.state.resultCancellationDelayDate })] }))] })] }));
        }
        else {
            return this.supportPortalTemplates.renderErrorPage();
        }
    };
    CancellationDelayPagePlain.prototype.renderErrors = function () {
        var errorsToRender = this.state.errors.map(function (error, index) { return ((0, jsx_runtime_1.jsx)("li", { children: error }, index)); });
        return (0, jsx_runtime_1.jsx)("ul", { className: "mb-1", children: errorsToRender });
    };
    CancellationDelayPagePlain.prototype.validate = function () {
        if (!this.state.delayDate) {
            return false;
        }
        var delayDate = new Date(this.state.delayDate.getTime());
        var maxDate = new Date(moment.parseZone(this.state.maxDate, "YYYY-MM-DD HH:mm:ss").toDate());
        maxDate.setUTCHours(23, 59, 59);
        var startOfToday = new Date();
        startOfToday.setUTCHours(0, 0, 0, 0);
        var delayDateIsBetweenStartDateAndEndDate = ((delayDate.getTime() >= startOfToday.getTime()) && (delayDate.getTime() < maxDate.getTime()));
        var errors = [];
        if (!this.state.delayDate) {
            errors.push("'Delay Date' is a mandatory field");
        }
        else if (!delayDateIsBetweenStartDateAndEndDate) {
            errors.push("'Delay Date' is not in range of the selected policy version");
        }
        this.setState({
            errors: errors
        });
        return errors.length === 0;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CancellationDelayPagePlain.prototype, "supportPortalService", void 0);
    CancellationDelayPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CancellationDelayPagePlain);
    return CancellationDelayPagePlain;
}(React.Component));
exports.CancellationDelayPagePlain = CancellationDelayPagePlain;
exports.default = (0, components_1.withRouter)(CancellationDelayPagePlain);
//# sourceMappingURL=CancellationDelayPage.js.map